import * as SessionStorage from "@omni/utils/sessionStorage.utils";
import { useEffect } from "react";

import { Spinner } from "@/components/General/Spinner/spinner.component";
import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { StorageKeys } from "@/utils/enums";

import {
    CUSTOMER_ORDER_LIST_PAGE_SIZE,
    useOrderList
} from "./hooks/useOrderList.hook";
import OrderList from "./orderList.component";

const OrderListContainer = () => {
    const { t } = useGranite();

    const { customerOrderList, loading, loadNextPage } = useOrderList();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const cartsMerged = SessionStorage.getItem(StorageKeys.CartsMerged);

        if (cartsMerged && cartsMerged === "true") {
            broadcastMessage({
                id: "carts-merged",
                text: `${t(
                    "account.cartsMerged.success"
                )} <a href="${Config.pages.cart}">${t(
                    "account.cartsMerged.toShoppingCart"
                )}</a>`,
                status: "success",
                dismissible: true
            });
        }
    }, []);

    if (customerOrderList.orders.length === 0) {
        return loading ? (
            <Spinner />
        ) : (
            <span>{t("account.orders.noOrders")}</span>
        );
    }

    return (
        <OrderList
            orders={customerOrderList.orders}
            totalNumberOfHits={customerOrderList.totalElements}
            totalPages={Math.ceil(
                customerOrderList.totalElements / CUSTOMER_ORDER_LIST_PAGE_SIZE
            )}
            loading={loading}
            loadNextPage={loadNextPage}
        />
    );
};

export { OrderListContainer };
